import { BellOutlined } from '@ant-design/icons';
import { Badge } from 'antd';
import React, { useEffect, useState } from 'react';
import styles from '../style/Notifications.module.scss';
import useHomeStore from "../../../../store/homeStore";
export default function Notifications() {
  const [showNotificationsDot, setShowNotificationsDot] = useState(false);

  const notifications = useHomeStore(state => state.notifications);

  useEffect(() => {
    setShowNotificationsDot(
      notifications && notifications.length > 0 ? true : false
    );
  }, [notifications]);

  function openNotifications() {
    setShowNotificationsDot(false);
  }

  return (
    <>
      <Badge
        dot={showNotificationsDot}
        className={styles.cartBadge}
        offset={[-4, 10]}
      >
        <BellOutlined onClick={openNotifications} className={styles.cartIcon} />
      </Badge>
    </>
  );
}
